<mapfre-modal
      [modalOptions]="leavePageModal"
      [hideModal]="hideModal"
      (closeModal)="resetHideModal($event)"
    >
      <div class="modal-docs-content modal-body no-margin-top">  
        <div class="modal-block margin-top mt24 text-center pb-4">
            <figure>
              <img src='./assets/img/images/icon-warning.svg' alt="icon warning" />
            </figure>
            <div class="bigger-font-size margin-top mt24">
              <div> {{ 'PLEASE_CONFIRM' | translate }} </div>
            </div>
            <div class="margin-top mt16 col-2d373d fs-16 lh-normal">
              {{ "YOU_EXIT_FILES_LOST" | translate }}
            </div>
        </div>

        <hr class="mt-2 mb-2" />

        <div class="row text-right pt-4">
            <div class="col show-btn-order">
                <mapfre-button [additionalClasses]="'ghost secondary small-btn modal-small-btn no-border mt-0 mr-0'"
                    [iconClasses]="'align-middle'" (click)="onClickExit()">
                    {{ 'Exit' | translate }}
                </mapfre-button>
                <mapfre-button [additionalClasses]="'basic primary small-btn modal-small-btn'"
                    (click)="onClickStay()">
                    {{ 'STAY_HERE' | translate }}</mapfre-button>
            </div>
        </div>
      </div>
    </mapfre-modal>